import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "list-parent" }
const _hoisted_2 = { class: "search-place" }
const _hoisted_3 = { class: "command-panel" }
const _hoisted_4 = { class: "labels-place" }
const _hoisted_5 = { class: "total-label" }
const _hoisted_6 = {
  key: 0,
  class: "selected-label"
}
const _hoisted_7 = { class: "table-parent" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "el-icon-more" }, null, -1)
const _hoisted_9 = { class: "paging-place" }
const _hoisted_10 = { class: "paging-label" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Showing ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" from ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" data ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchInput = _resolveComponent("SearchInput")
  const _component_TableHeaderComponent = _resolveComponent("TableHeaderComponent")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_SearchInput, {
        modelValue: _ctx.state.search,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.search = $event)),
        "debounce-time": 500,
        onDebounceInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchChanged()))
      }, null, 8, ["modelValue"]),
      _createVNode("button", {
        class: "button",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addSite()))
      }, " + Add site ")
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("span", _hoisted_5, "Total: " + _toDisplayString(_ctx.state.paging.total), 1),
        (_ctx.list.selected.length)
          ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(_ctx.list.selected.length) + " selected ", 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _withDirectives(_createVNode(_component_el_table, {
        class: "list-table",
        ref: "multipleTable",
        data: _ctx.list.data,
        style: {"width":"100%"},
        "header-row-class-name": "header-row",
        stripe: true,
        "select-on-indeterminate": false,
        "empty-text": "Nothing is found. Please change your search parameters",
        onSelectionChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectionChange($event)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "Site Name",
            "min-width": "150",
            fixed: ""
          }, {
            header: _withCtx(() => [
              _createVNode(_component_TableHeaderComponent, {
                header: 'Site Name',
                filterable: true,
                filterData: _ctx.state.filtersData.sites,
                sortable: true,
                sortingValue: _ctx.getSortingValueForField(_ctx.fieldNames.siteName),
                onChangeSorting: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sortingChange(_ctx.fieldNames.siteName, $event)))
              }, null, 8, ["filterData", "sortingValue"])
            ]),
            default: _withCtx((scope) => [
              _createVNode("a", {
                href: "#",
                onClick: _withModifiers(($event: any) => (_ctx.viewSite(scope.row)), ["prevent"])
              }, _toDisplayString(scope.row.name), 9, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "Country",
            width: "170"
          }, {
            header: _withCtx(() => [
              _createVNode(_component_TableHeaderComponent, {
                header: 'Country',
                filterable: true,
                filterData: _ctx.state.filtersData.countries,
                sortable: true,
                sortingValue: _ctx.getSortingValueForField(_ctx.fieldNames.country),
                onChangeSorting: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortingChange(_ctx.fieldNames.country, $event)))
              }, null, 8, ["filterData", "sortingValue"])
            ]),
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.country_name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "Number of assesments",
            "min-width": "240"
          }, {
            header: _withCtx(() => [
              _createVNode(_component_TableHeaderComponent, {
                header: 'Number of assessments',
                sortable: false,
                sortingValue: 
                _ctx.getSortingValueForField(_ctx.fieldNames.number_of_assessments)
              ,
                onChangeSorting: _cache[6] || (_cache[6] = ($event: any) => (
                _ctx.sortingChange(_ctx.fieldNames.number_of_assessments, $event)
              ))
              }, null, 8, ["sortingValue"])
            ]),
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row[_ctx.fieldNames.number_of_assessments]), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            "class-name": "actions-cell",
            label: "Actions",
            fixed: "right",
            width: "83"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_dropdown, {
                type: "primary",
                trigger: "click"
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.operations, (operation) => {
                        return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                          class: { 'delemiter-after': operation.delemiterAfter },
                          key: operation.action,
                          onClick: ($event: any) => (_ctx.handleAction(operation.action, scope.row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(operation.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["class", "onClick"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    disable: _ctx.operations.length
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }, 8, ["disable"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]), [
        [_directive_loading, _ctx.state.isLoading]
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode("span", null, _toDisplayString(_ctx.list.data.length), 1),
          _hoisted_12,
          _createVNode("span", null, _toDisplayString(_ctx.state.paging.total), 1),
          _hoisted_13
        ]),
        (_ctx.state.paging.total > _ctx.state.paging.pageSize)
          ? (_openBlock(), _createBlock(_component_el_pagination, {
              key: 0,
              class: "table-paging",
              layout: "prev, pager, next",
              "current-page": _ctx.state.paging.page,
              "page-size": _ctx.state.paging.pageSize,
              "pager-count": 5,
              total: _ctx.state.paging.total,
              onCurrentChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.pageChange($event)))
            }, null, 8, ["current-page", "page-size", "total"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}